import * as React from "react";
import styled from "react-emotion";
import { observer, inject } from "mobx-react";
import { theme } from "../../styles/theme";
import Panda from "../Panda";
import Media from "../Media";
import Link from "gatsby-link";

const Header = styled.div`
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  font-family: ${theme.sans.fontFamily};
  font-weight: 700;
`;

const Item = styled.div`
  padding: ${theme.space2};
  cursor: pointer;
`;

const Header_ = ({ toggleMenu }) => (
  <Header>
    <Item>
      <Link to="/">PaNDaGOAT</Link>
    </Item>
    <Item onClick={() => toggleMenu("MEDIA")}>MEDIA</Item>
  </Header>
);

export default inject(({ store }) => ({
  toggleMenu: store.appStore.toggleMenu
}))(observer(Header_));



// WEBPACK FOOTER //
// ./src/components/Header/index.js